import { catchError, delay, map } from "rxjs/operators";
import { forkJoin, of, BehaviorSubject, Observable } from "rxjs";
import { ApiConstant, UtilService } from "../../constants/app.constant";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ErrorHandlers } from "src/app/utilities/error.handlers";
import { SnackBarService } from "../snack-bar/snack-bar.service";
import { NavigationItem } from "src/app/admin/navigation/navigation";
import { IResp } from "src/app/metadata/interfaces/IResp";
import { AuthSignInClass } from "src/app/metadata/objects/authentication/auth-signin/AuthSignInClass";

const USER_KEY = "auth-user";
const BASE_API = `${ApiConstant.baseUrlV2}` + "Account/Token";

@Injectable({
  providedIn: "root",
})
export class AuthSignInService {
  _CurrentUser: BehaviorSubject<any> = new BehaviorSubject(null);
  _TokenIsV2: boolean = false;
  _LoggedIn: boolean = false;
  _LoginSimulation: boolean = false;

  _LoginData: any;
  _LoginDataSubject = new BehaviorSubject<any>({
    isloading: false,
    loggedin: false,
    loginsuccess: false,
  });

  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private _SnackBarService: SnackBarService
  ) {}

  _LoginWithMockData(): Observable<IResp> {
    try {
      return of({
        _Status: true,
        _Data: AuthSignInClass._SendUserInfoData(),
        _ErrorCode: 0,
      }).pipe(delay(2000));
    } catch (Error) {
      return of({
        _Status: false,
        _Data: "An error occured",
        _ErrorCode: 0,
      });
    }
  }

  _ErrorHandler(err) {
    return;
    if (err?.length > 60)
      this._SnackBarService.showSnackBar(
        (err as string).slice(0, 60) + "...",
        false
      );
    else this._SnackBarService.showSnackBar(err as string, false);
  }

  _LogInUser(Data: any) {
    const httpoptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
    };
    return this.httpClient
      .post<any>(BASE_API, Data, httpoptions)
      .pipe(catchError(ErrorHandlers.HandleError));
  }

  _GetAuthenticatedUserInfoV2(Username: string): Observable<IResp> {
    let url = `${ApiConstant.baseUrlV2}User/GetUserInfo?Email=${Username}`;
    return this.httpClient.post<any>(url, {}).pipe(
      map((Response) => ({
        _Status: true,
        _Data: Response,
        _ErrorCode: 0,
      })),
      catchError((Error) =>
        of({
          _Status: false,
          _Data: Error,
          _ErrorCode: 0,
        })
      )
    );
  }

  _IsLoggedIn() {
    return !!localStorage.getItem("token");
  }

  // get stored data
  _GetUser() {
    return this._CurrentUser.asObservable();
  }

  //check whether a user is permitted to view this page or not
  _HasPermission(Permissions: string[]): boolean {
    if (this._CurrentUser.value.permission) {
      for (let permission of Permissions) {
        if (
          !this._CurrentUser.value ||
          !this._CurrentUser.value.permission.includes(permission)
        )
          return false;
      }
      return true;
    } else {
      return false;
    }
  }

  _GetCurrentUserRoles() {
    return this.httpClient.get(
      `${ApiConstant.baseUrlV2}userroles/GetCurrentUserRoles`
    );
  }

  _GetRolePermissions(RoleIds: string[]) {
    let requests = [];
    RoleIds.forEach((roleId) => {
      requests.push(
        this.httpClient
          .get(`${ApiConstant.baseUrlV2}userroles/ListRolePermission/${roleId}`)
          .pipe(
            catchError((err) => {
              return of(err.status);
            })
          )
      );
    });
    return forkJoin(requests);
  }

  _SaveLoginToken(Val: any, LoginData: any) {
    this._TokenIsV2 = true;
    sessionStorage.setItem("token", btoa(`Bearer ${Val.access_token}`));
    sessionStorage.setItem("expires", btoa(Val[".expires"]));
    sessionStorage.setItem("username", LoginData.username);
  }

  _UserLogin(LoginData: any): Observable<IResp> {
    this._LoginData = LoginData;

    let url = ApiConstant.baseUrlV2 + "Account/Token";

    const data = new HttpParams()
      .set("username", LoginData.username)
      .set("password", LoginData.password)
      .set("grant_type", "password");

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return this.httpClient.post(url, data, { headers }).pipe(
      map((Response) => ({
        _Status: true,
        _Data: Response,
        _ErrorCode: 0,
      })),
      catchError((Error) =>
        of({
          _Status: false,
          _Data: Error,
          _ErrorCode: Error.status || 500,
        })
      )
    );
  }

  _FirstLevelLogin(LoginData: any): Observable<IResp> {
    this._LoginData = LoginData;

    //// const url = "http://localhost:44383/api/v1/Account/Token";

    let url = ApiConstant.baseUrlV2 + "Account/Token";

    const data = new HttpParams()
      .set("username", LoginData.username)
      .set("password", LoginData.password)
      .set("grant_type", "password");

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return this.httpClient.post(url, data, { headers }).pipe(
      map((Response) => ({
        _Status: true,
        _Data: Response,
        _ErrorCode: 0,
      })),
      catchError((Error) =>
        of({
          _Status: false,
          _Data: Error,
          _ErrorCode: Error.status || 500,
        })
      )
    );
  }

  // _FirstLevelLogin(LoginData: any): Observable<IResp> {
  //   this._LoginData = LoginData;
  //   // let url = ApiConstant.baseUrlV2CoreApi + "Account/Token";
  //   let url =  "http://localhost:44383/api/v1/Account/Token";

  //   const data = new HttpParams()
  //     .set("username", LoginData.username)
  //     .set("password", LoginData.password)
  //     .set("grant_type", "password");

  //   // const data = new URLSearchParams();
  //   // data.append("username", LoginData.username);
  //   // data.append("password", LoginData.password);
  //   // data.append("grant_type", "password");

  //   const headers = new HttpHeaders({
  //     "Content-Type": "application/x-www-form-urlencoded",
  //     "Access-Control-Allow-Origin": "*",
  //   });

  //   return this.httpClient.post(url, data, { headers }).pipe(
  //     map((Response) => ({
  //       _Status: true,
  //       _Data: Response,
  //       _ErrorCode: 0,
  //     })),
  //     catchError((Error) =>
  //       of({
  //         _Status: true,
  //         _Data: Error,
  //         _ErrorCode: 0,
  //       })
  //     )
  //   );
  // }

  _AuthenticateUserLogin(Resp: any): Observable<IResp> {
    if (Resp?._SysNumber === undefined || Resp?._SysNumber <= 0) {
      if (Resp.Message == undefined)
        this._SnackBarService.showLoginSnackBarV2(
          "Authentication has failed on site, Make sure to have your on-site server online or deployed !",
          "danger"
        );
      else this._SnackBarService.showLoginSnackBarV2(Resp.Message, "danger");
      return;
    }

    sessionStorage.setItem("Perm", btoa(JSON.stringify(Resp)));

    return this._GetAuthenticatedUserInfoV2(this._LoginData.username.trim());
  }

  _SecondLevelLogin(LoginData: any): Observable<IResp> {
    let url = ApiConstant.baseUrlV2 + "Account/Token";
    const data = new HttpParams()
      .set("username", LoginData.username)
      .set("password", LoginData.password)
      .set("grant_type", "password");

    return this.httpClient
      .post<any>(url, data, {
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        map((Response) => ({
          _Status: true,
          _Data: Response,
          _ErrorCode: 0,
        })),
        catchError((Error) =>
          of({
            _Status: false,
            _Data: Error,
            _ErrorCode: 0,
          })
        )
      );
  }

  _SaveSecondLevelToken(Val: any, LoginData: any): Observable<IResp> {
    this._TokenIsV2 = true;
    sessionStorage.setItem("token", btoa(`Bearer ${Val.access_token}`));
    sessionStorage.setItem("expires", btoa(Val[".expires"]));
    sessionStorage.setItem("username", LoginData.UserName);
    return this._ConfirmbaseUrlV2Authentication(LoginData);
  }

  _SaveFirstLevelToken(Val: any, LoginData: any): Observable<IResp> {
    sessionStorage.setItem("TK", btoa(JSON.stringify(Val)));
    sessionStorage.setItem("tokenCore", btoa(`Bearer ${Val.access_token}`));
    return this._ConfirmCoreAuthenticationApi(LoginData);
  }

  _ConfirmCoreAuthenticationApi(LoginData: any): Observable<IResp> {
    let url = ApiConstant.baseUrlV2 + "Account/ConfirmAuthentication";
    var data = {
      UserName: LoginData.UserName,
      Password: LoginData.PassWord,
      ConfirmPassword: LoginData.PassWord,
    };

    return this.httpClient
      .post(url, data, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          authorization: "Bearer " + UtilService.GetTK(),
        }),
      })
      .pipe(
        map((Response) => ({
          _Status: true,
          _Data: Response,
          _ErrorCode: 0,
        })),
        catchError((Error) =>
          of({
            _Status: true,
            _Data: Error,
            _ErrorCode: 0,
          })
        )
      );
  }

  _ConfirmbaseUrlV2Authentication(LoginData: any): Observable<IResp> {
    let url = ApiConstant.baseUrlV2 + "Account/ConfirmAuthentication";
    var data = {
      UserName: LoginData.UserName,
      Password: LoginData.PassWord,
      ConfirmPassword: LoginData.PassWord,
    };

    return this.httpClient
      .post<any>(url, data, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          authorization: UtilService.GetTOKENKV2(),
        }),
      })
      .pipe(
        map((Response) => ({
          _Status: true,
          _Data: Response,
          _ErrorCode: 0,
        })),
        catchError((Error) =>
          of({
            _Status: false,
            _Data: Error,
            _ErrorCode: 0,
          })
        )
      );
  }

  _OnFailure(Val: any): void {
    if (!navigator.onLine)
      this._SnackBarService.showLoginSnackBarV2(
        "No Internet Connection, please check your network connection and try again.",
        "danger"
      );
    else
      this._SnackBarService.showLoginSnackBarV2(
        "Incorrect login credentials, retry again !",
        "danger"
      );
  }

  LogOut(DoNotRedirect: boolean = false): void {
    this._TokenIsV2 = false;
    var user = JSON.parse(atob(sessionStorage.getItem("userInfo")));

    sessionStorage.clear();

    !DoNotRedirect;
    this.router.navigate(["/auth/signin"]);
  }
}
